import React, {Component} from 'react'
import axios from 'axios'
import Modal from 'react-modal'

import Config from '../Configs/staticConfig'

class ShareDialog extends Component{
    constructor(props){
        super(props)
        this.state = {
            shortLink : null
        }

        this.dismissShare = this.dismissShare.bind(this)
        this.handleCopy = this.handleCopy.bind(this)
        this.handleShareToLine = this.handleShareToLine.bind(this)
        this.handleShareToFacebook = this.handleShareToFacebook.bind(this)
    }

    componentWillReceiveProps(nextProps){
        if( nextProps.isOpenShareDialog ) {
            var body = { link : window.location.href }
            axios.post(Config.getShortLinkReqeustUrl(),body)
            .then(res=>{
                this.setState({shortLink:res.data.link})
            })
        }
        
    }

    dismissShare(){
        this.props.setIsOpenShareDialog(false)
    }

    handleCopy(){
        var copyText = document.getElementById("linkForCopy");
        copyText.select();
        document.execCommand("copy");
        alert("Copied");
    }

    handleShareToLine(){
        const { shortLink } = this.state
        this.dismissShare()
        window.open('https://social-plugins.line.me/lineit/share?url='+shortLink)
    }

    handleShareToFacebook(){
        const { shortLink } = this.state
        this.dismissShare()
        window.FB.ui({
            method:'share',
            display:'popup',
            href:shortLink
        })     
    }

    render(){
        const { shortLink } = this.state
        const { isOpenShareDialog } = this.props

        var modalContent = null 
        if ( shortLink !== null ){
            modalContent =  <div className="content">
                                <h4 className="UploadProgressHeading title is-size-4 is-size-5-mobile has-text-white">Share</h4>
                                <div className="divBtn">
                                    <input className="input is-rounded" type="text" value={shortLink} id="linkForCopy" readOnly/>
                                    <i className="far fa-copy is-right-inner" onClick={this.handleCopy}></i>
                                </div>
                                <div className="divBtn">
                                    <input className="button is-facebook is-rounded is-maxwidth" type="submit" value="แชร์ Facebook" onClick={this.handleShareToFacebook}/>
                                    <i className="fab fa-facebook-square is-left-inner"></i>
                                </div>
                                <div className="divBtn">
                                    <input className="button is-line is-rounded is-maxwidth" type="submit" value="แชร์ Line" onClick={this.handleShareToLine}/>
                                    <i className="fab fa-line is-left-inner" ></i>
                                </div>
                            </div>
        }
        else if ( shortLink === null ){
            modalContent =  <span className="MapsDetailsLoadingIcon icon is-medium">
                                <i className="fas fa-spinner fa-pulse fa-2x"></i>
                            </span>
        }
        return  <Modal  isOpen={isOpenShareDialog}
                        onRequestClose={this.dismissShare} 
                        className="modal is-active"
                        overlayClassName="modal-overlay"
                        htmlOpenClassName="ReactModal__Html--open">

                        <div className="modal-background"></div>
                        <div className="modal-content modal-alert">
                            <div className="UploadProgressContentBox box">
                                { modalContent }
                                <div className="UploadProgressClose icon is-large has-text-grey" onClick={this.dismissShare}><i className="fas fa-times"></i></div>
                            </div> 
                        </div>
                </Modal>
    }
}

export default ShareDialog


// WEBPACK FOOTER //
// ./src/PageMaps/_ShareDialog.js